import { render, staticRenderFns } from "./PregnancyClassInfo.vue?vue&type=template&id=05be3b40&scoped=true&"
import script from "./PregnancyClassInfo.vue?vue&type=script&lang=js&"
export * from "./PregnancyClassInfo.vue?vue&type=script&lang=js&"
import style0 from "./PregnancyClassInfo.vue?vue&type=style&index=0&id=05be3b40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05be3b40",
  null
  
)

export default component.exports